import type {
  ShapeInterestLender,
  ShapeLenderBase,
  ShapeProfitShareLender,
} from "@aprao/model/src/shapes/ShapeLender.js";

export const buildLenderName = (
  lender: ShapeInterestLender | ShapeProfitShareLender,
  lenders: Array<ShapeLenderBase>,
) => {
  return lender.name.length === 0 ?
      `Lender ${lenders.indexOf(lender) + 1}`
    : lender.name;
};
